import { IActionBase, ISMSTemplatesState } from "../models/root.interface";
import { ADD_SMS_TEMPLATE, CLEAR_SMS_TEMPLATES, DELETE_TEMPLATE_IDS, GET_DATA, DELETE_TEMPLATE_TITLE} from "../actions/SMSTemplates.action";
import { string } from "prop-types";

const initialState: ISMSTemplatesState = {
    SMSTemplates: [],
    smsTemplatesData: {},
    smsTemplateDeleteIds: [],
    smsTemplateTitle: "",
};
function SMSTemplatesReducer(state: ISMSTemplatesState = initialState, action: IActionBase): ISMSTemplatesState {
    switch (action.type) {
        case ADD_SMS_TEMPLATE: {
            let maxId: number = Math.max.apply(Math, state.SMSTemplates.map(o => o.id));
            if (maxId === -Infinity) { maxId = 0; }
            let newItem = {
                id: maxId + 1,
                templateId: action.templateId,
                channelId: action.channelId,
                name: action.name,
                status: action.status,
            };
            return { ...state, SMSTemplates: [...state.SMSTemplates, newItem] };
        }
        case CLEAR_SMS_TEMPLATES:
            return { ...state, SMSTemplates: [] };
        case GET_DATA:
            return { ...state, smsTemplatesData: action.payload }
        case DELETE_TEMPLATE_IDS:
            return { ...state, smsTemplateDeleteIds: action.payload, smsTemplateTitle: action.title }
        case DELETE_TEMPLATE_TITLE:
            return { ...state, smsTemplateTitle: "" }    
        default:
            return state;
    }
}


export default SMSTemplatesReducer;